import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";
import { LANDING } from "@/constants/testIds";

const WHATSAPP_URL = "https://wa.me/917208286283";

export default function CTA() {
  const navigate = useNavigate();
  return (
    <section className="section cta-section">
      <div className="section-inner" style={{ textAlign: "center" }}>
        <Reveal className="eyebrow cream cta-eyebrow" style={{ marginLeft: "auto", marginRight: "auto" }}>
          Ready to Give Back?
        </Reveal>
        <Reveal as="h2" delay={1} className="cta-headline">
          Start planting with
          <br />
          <em>your next order.</em>
        </Reveal>
        <Reveal as="p" delay={2} className="cta-body">
          Every Utsah hamper automatically includes The Green Gift Initiative. No extra steps. No extra cost. Just order — and a tree grows in India.
        </Reveal>
        <Reveal delay={3} className="cta-row">
          <button
            className="btn-primary"
            data-testid={LANDING.ctaExploreCollections}
            onClick={() => navigate("/diwali-collection")}
          >
            Explore Collections
          </button>
          <a
            className="btn-secondary"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer noopener"
            data-testid={LANDING.ctaWhatsapp}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" />
            </svg>
            Chat on WhatsApp
          </a>
        </Reveal>
      </div>
    </section>
  );
}
